// https://codesandbox.io/s/react-select-v2-required-input-3xvvb?fontsize=14
import React from "react";
import PropTypes from "prop-types";

const noop = () => {
    // no operation (do nothing real quick)
};

class RequiredSelect extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            value: props.value || ""
        };
        this.selectRef = React.createRef();

        this.onChange = this.onChange.bind(this);
        this.getValue = this.getValue.bind(this);
    }

    onChange(value, actionMeta) {
        this.props.onChange(value, actionMeta);
        this.setState({ value });
    }

    getValue() {
        if (this.props.value != undefined) return this.props.value;
        return this.state.value || "";
    }

    render() {
        const { SelectComponent, required, ...props } = this.props;
        const { isDisabled } = this.props;
        const enableRequired = !isDisabled;

        return (
            <div style={{ position: "relative" }}>
                <SelectComponent
                    {...props}
                    ref={this.selectRef}
                    onChange={this.onChange}
                />
                {enableRequired && (
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{
                            opacity: 0,
                            width: "100%",
                            height: 0,
                            position: "absolute"
                        }}
                        value={this.getValue()}
                        onChange={noop}
                        onFocus={() => this.selectRef.current.focus()}
                        required={required}
                    />
                )}
            </div>
        );
    }
}

RequiredSelect.defaultProps = {
    onChange: noop
};

RequiredSelect.protoTypes = {
    // react-select component class (e.g. Select, Creatable, Async)
    selectComponent: PropTypes.func.isRequired,
    onChange: PropTypes.func,
    required: PropTypes.bool
};

export default RequiredSelect;
